import { CodeLegend } from "./CodeLegend.tsx";
import { ABOUT_SECTIONS } from "./about.constants.ts";
import "./about.css";

export function About() {
  return (
    <section className="about">
      {ABOUT_SECTIONS.map((section) => (
        <article key={section.key} className="about__section">
          <h2 className="about__title">{section.title}</h2>
          <p className="about__body">{section.body}</p>
        </article>
      ))}

      {/* Last, because it is the one section somebody arrives at with a
          question rather than reading through: they saw a colour on a work and
          came here to find out what it meant. */}
      <CodeLegend />
    </section>
  );
}
